import 'Components/quick-help';

const $content = $('.b-quick-help');

if ($content.length > 0) {
  window.translator.load().then(() => {
    ko.applyBindings({}, $content.get()[0]);
  });
}
